module.exports = __webpack_public_path__ + "static/media/ExerciseIconMathBig.783e0713.svg";